<template>
  <form>
    <div class="container d-flex flex-column justify-content-center align-items-center" style="padding-right: 0 !important; padding-left: 0 !important; padding-top: 0 !important;">
      <div class="row" style="padding: 20px; width: 40%; margin-top: 30px">
        <img src="https://silkplm.com/wp-content/uploads/2024/11/Product-Tour-welcome-screen.png" style="width: 100%">
      </div>
      <div class="row">
        <div class="col mt-5 py-3 text-center">
          <h4>
            {{$tr('signup-progress-title', "A few more seconds to go, we are creating your account.")}}
          </h4>
        </div>
      </div>
      <div class="row ">
        <h5 class="col text-center" v-if="stage === 'started'">
          {{$tr('signup-progress-started', "Setting up a new account")}}
        </h5>
        <h5 class="col text-center" v-else-if="stage === 'roles'">
          {{$tr('signup-progress-roles', "Creating roles")}}
        </h5>
        <h5 class="col text-center" v-else-if="stage === 'config'">
          {{$tr('signup-progress-conf', "Setting up initial configuration")}}
        </h5>
        <h5 class="col text-center" v-else-if="stage === 'data'">
          {{$tr('signup-progress-data', "Generating sample data")}}
        </h5>
        <h5 class="col text-center" v-else-if="stage === 'complete'">
          {{$tr('signup-progress-complete', "Setup complete!")}}
        </h5>
        <h5 class="col text-center" v-else>
          {{$tr('signup-progress-other', "Setting up system")}}
        </h5>
      </div>

      <div class="row pb-2">
        <div class="progress data-loading" data-test-path="loading-indicator" style="height: 8px; width: 300px; margin-top: 12px">
          <div
              class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
              role="progressbar"
              style="width: 100%">
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import Rpc from "@/Rpc";

import SessionManager from "@/utils/SessionManager";
import Loading from "@/components/layout/Loading.vue";


export default {
  name: "SignUpInProgress",
  components: {Loading},

  created() {
  },

  beforeMount() {
  },

  async mounted() {
    this.check();
  },

  methods: {
    async check() {
      try {
        let userInfo = await Rpc.Session.userInfo();
        this.stage = userInfo.organizationSetupProgress;
        if (this.stage === "complete") {
          await this.finishSignUp(userInfo);
          return
        }
      } catch (e){
        console.log(e);
      }

      setTimeout(() => this.check(), 2000);

    },
    async finishSignUp(userInfo) {
        await SessionManager.installRuntimeCode();
        await SessionManager.preSignIn(true);
        SessionManager.setUserInfo(userInfo);
        await SessionManager.postSignIn();
    },

  },
  data: () =>(
    {
      userInfo: null,
      stage: ""
    }
  )
}
</script>

<style lang="sass" scoped>

  @import '../styles/signin-signup'

  #captchaContainer
    margin-top: 15px

  .invitation
    font-size: 15px

  @media screen and (max-width: 995px)
    .invitation
      font-size: 12px

  @media screen and (max-width: 770px)
    .invitation
      font-size: 15px

  @media screen and (max-width: 400px)
    .invitation
      font-size: 12px

</style>